import Image, { ImageProps } from 'next/image';

import { HTMLDataTrackerProps } from '@/app/types';
import { cn } from '@/lib/utils';

export type NextImageProps = {
  classNames?: {
    container?: string;
    image?: string;
  };
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
  placeholder?: 'blur' | 'empty';
  customSrcSet?: { url: string; width: number; height: number }[];
} & Omit<ImageProps, 'children'> &
  HTMLDataTrackerProps;

export default function NextImage({
  src,
  width,
  height,
  alt,
  objectFit,
  classNames,
  customSrcSet,
  quality = 75,
  ...props
}: NextImageProps) {
  return (
    <div className={cn('relative min-w-fit', classNames?.container)}>
      <picture>
        {customSrcSet
          ?.sort((a, b) => a.width - b.width)
          .map((srcSet) => (
            <source
              key={srcSet.url}
              srcSet={srcSet.url}
              media={`(max-width: ${srcSet.width}px)`}
            />
          ))}
        <Image
          className={cn(classNames?.image)}
          src={src}
          alt={alt || ''}
          fill={width || height ? false : true}
          width={width || 0}
          height={height || 0}
          quality={quality}
          style={{
            objectFit: objectFit || 'contain',
          }}
          data-tracker-component='next-image'
          {...props}
        />
      </picture>
    </div>
  );
}
